const cs = {
  common: {
    wallet: "peněženka",
    playPage: "hrát",
    minTop: "minimální částka je $10",
    maxTop: "maximální částka je $500",
    website: "webová stránka",
    signOut: "odhlásit se",
    hidden: "skrytý",
    victory: "vítězství",
    wentWrong: "něco se pokazilo, přesměrování",
    stakeLabel: "sázka",
    howDoes: "jak to funguje?",
    continue: "Pokračovat",
    continueWithGoogle: "Pokračovat s Google",
    continueWithApple: "Pokračovat s Apple",
    termsOfService: "podmínky služby",
    privacyPolicy: "zásady ochrany osobních údajů",
    termsOfServiceFooter: "podmínky služby",
    privacyPolicyFooter: "zásady ochrany osobních údajů",
    verificationCode: "ověřovací kód",
    verify: "ověřit",
    account: "účet",
    error: "došlo k chybě\n",
    checkBackLater: "zkontrolujte to později",
    looking: "hledání...",
    yes: "ano",
    no: "ne",
    pleaseSelect: "Prosím vyberte\n",
    disclaimer: "pokračováním souhlasíte s našimi\n",
    and: "a",
  },
  endOfGame: {
    wonByCheckmate: "vyhráno šachmatem",
    lostOnTime: "prohra na čas",
    resigns: "rezignace",
    gameDrawnByAgreement: "hra remizována dohodou",
    abandonedTheGame: "hra opuštěna",
    gameAborted: "hra přerušena",
    gameDrawnByStalemate: "hra remizována patem",
    gameDrawnByFiftyMoveRule: "hra remizována pravidlem padesáti tahů",
    gameDrawnByInsufficientMaterial: "hra remizována nedostatkem materiálu",
    gameDrawnByThreefoldRepetition: "hra remizována trojím opakováním pozice",
    draw: "remíza",
    victory: "vítězství",
    defeat: "porážka",
    aborted: "přerušeno",
    white: "bílý",
    black: "černý",
    inspectBoard: "zobrazit desku",
    returnToEndOfGameModal: "pokračovat",
  },
  byPhone:{
    continueOnPhone: "pokračovat na\ntelefonu",
    or: "nebo",
    continueOnWeb: "pokračovat ve\nwebovém prohlížeči",
    disclaimer: "vhodné pokud máte fotografii svého ID na disku"
  },
  signUp: {
    email: "e-mail",
    username: "uživatelské jméno",
    usernameInvalid: "neplatné uživatelské jméno",
    emailInvalid: "neplatný e-mail",
    login: "přihlášení",
    continueWithPhone: "pokračovat s telefonním číslem",
    tickBoxes: "zaškrtněte několik\npolíček",
    confirm: "Potvrzuji, že\n",
    resideIn: "Bydliště\n",
    notPEP: "Nejsem politicky exponovaná osoba (PEP), člen rodiny nebo známý přidružené osoby PEP\n",
    purpose: "Účel a povaha mého vztahu s Gambit je výhradně pro použití služby pro zábavu\n",
    soleBenefit: "Službu budu používat výhradně pro svůj vlastní prospěch a neexistuje žádný další skutečný majitel\n",
  },
  identity: {
    beingVerified: "identita\nje ověřována",
    verified: "ověřeno\n",
    failed: "ověření\nselhalo",
  },
  payment: {
    failed: "platba selhala.\nprosím zkuste to znovu",
    successful: "platba\núspěšná!",
    toppedUp: "jste\ndoplňeni!",
    topUp: "doplnění\n",
    payWith: "zaplatit s...\n",
  },
  gameplay: {
    play: "hrát\n",
    challenge: "vás vyzývá k",
    gameWorth: "hodnota hry\n",
    whatsYourNumber: "jaké je vaše\ntelefonní číslo?",
    receiveCode: "brzy obdržíte ověřovací\nkód",
    matchedOpponent: "Budete spárováni s protihráčem s podobným hodnocením.",
    stake: {
      total: "Celková sázka bude částka vybraná níže.",
      contribution: "Přibližně polovinu této částky přispějete.",
      weakerOpponent: "Pokud budete spárováni s slabším protihráčem, zaplatíte větší část sázky.",
      strongerOpponent: "Pokud budete spárováni s silnějším protihráčem, zaplatíte menší část sázky.",
    },
    supportInfo: "Pro více informací navštivte naši podporu.\n",
    continueBrowser: "pokračovat ve\nwebovém prohlížeči",
    continuePhone: "pokračovat na\ntelefonu",
    getStarted: "začněme\n",
    sentText: "poslali jsme vám\nSMS",
    enterReceivedCode: "zadejte přijatý\nověřovací kód",
    wrongCode: "špatný kód, zkuste to znovu\n",
    secPerMove: "sekund na tah",
    resign: {
      prompt: "jste si jistí, že chcete rezignovat?",
    },
    draw: {
      offer: "přijmout nabídku remízy?",
    },
    rating: "hodnocení\n",
    balance: "zůstatek\n",
    rematch: "odveta\n",
    newOpponent: "nový protihráč\n",
    home: "domů\n",
    rematchOffer: "váš protihráč nabízí odvetu. přijmout?",
    leaveGame: "Momentálně hrajete hru. Jste si jistí, že chcete odejít?",
    room: "místnost:\n",
    gameTypes: {
      bullet: {
        title: "bullet\n",
        description: "Šach plný adrenalinu. Vy a váš protihráč máte k vítězství pouze 1 minutu.",
      },
      blitz: {
        title: "blitz\n",
        description: "Vy a váš protihráč máte k vítězství 3 minuty.",
      },
    },
    stakes: {
      unlockNext: "hrajte {amount} dalších her pro odemčení další sázky",
      allUnlocked: "všechny sázky odemčeny",
    },
    withdraw: "vybrat\n",
  },
  puzzle: {
    begin: "začít",
    next: "další",
    unavailableInYourRegion: "nedostupné",
    puzzle: "hádanka",
    whiteToPlay: "bílý na tahu",
    blackToPlay: "černý na tahu",
    time: "čas",
    solution: "řešení",
    somethingWentWrong: "něco se pokazilo",
    rating: "hodnocení",
    credits: "kredity",
    puzzleFailed: "prohra",
    puzzleSolved: "výhra",
    correct: "správné řešení",
    incorrect: "špatné řešení",
    youRanOutOfTime: "vypršel vám čas",
    puzzleDescription: "Máte 10 sekund + 2 sekundy/tah na vyřešení hádanky.",
    creditsLeft: "zbývající kredity",
    refillIn: "doplnit za",
    lastPuzzle: "Toto je vaše poslední hádanka, vraťte se později pro další.",
    outOfCredits: "Došly vám kredity, vraťte se později.",
    locationPrompt: "Potřebujeme vaši polohu k pokračování. Pokud je zablokována, prosím, znovu ji povolte:",
    locationInstructions: "Klikněte na ikonu v adresním řádku, vyberte 'Vždy povolit' a obnovte stránku",
    creditsError: "Chyba při načítání kreditů",
    moves: "Tahy:",
  },
};

export {cs};